export const ROOT_URL = import.meta.env.VITE_ROOT_URL
export const MUI_KEY = import.meta.env.VITE_MUI_KEY
export const SENTRY_KEY = import.meta.env.VITE_SENTRY_KEY
export const REACT_APP_SERVER_BRANCH = import.meta.env.VITE_SERVER_BRANCH
export const MAP_KEY = import.meta.env.VITE_MAP_KEY
export const SOCKET_URL = import.meta.env.VITE_SOCKET_URL
